var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: _vm.genericPopupId, role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-header generic-header" },
            [
              [
                _c("span", { staticClass: "col-md-12 pt-10" }, [
                  _vm._v(_vm._s(_vm.genericHeader)),
                ]),
              ],
            ],
            2
          ),
          _c("div", { staticClass: "modal-body generic-body" }, [
            _vm.genericBody
              ? _c("div", { staticClass: "col-md-12 p-10" }, [
                  _c("div", [
                    _c(
                      "p",
                      [
                        _vm._v(
                          " Your account is currently limited to a maximum of " +
                            _vm._s(
                              _vm.isREP ? this.max_number - 1 : this.max_number
                            ) +
                            " "
                        ),
                        _vm.genericBody === "upgradeTeams"
                          ? [_vm._v("members.")]
                          : _vm._e(),
                        _vm.genericBody === "upgradeRecords"
                          ? [_vm._v("records.")]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("p", { staticClass: "inlineStyle" }, [
                      _vm._v(" Please "),
                      _c(
                        "span",
                        {
                          staticClass: "rams_url cursor-pointer",
                          on: { click: _vm.upgrade },
                        },
                        [_vm._v("Click here")]
                      ),
                      _vm._v(" if you would like to upgrade your account. "),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "modal-footer", staticStyle: { clear: "both" } },
            [
              _c(
                "button",
                {
                  staticClass: "btn emergo-green-button",
                  attrs: { type: "button" },
                  on: { click: _vm.closePopupOnOk },
                },
                [_vm._v("OK")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }